/**
 * Pre-compiled pt-BR messages for DateRangePicker
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  clearInput: `Limpar valores inseridos`,
  clearSelection: `Limpar intervalo de datas`,
  endTime: `Hora de término`,
  endTimeHour: `Hora de término (hora)`,
  endTimeHourMinute: `Hora de término (hora e minutos)`,
  endTimeHourMinuteSecond: `Hora de término (hora, minutos e segundos)`,
  endTimeLabel: `Hora de término`,
  openCalendar: `Abrir agenda`,
  startTime: `Hora de início`,
  startTimeHour: `Hora de início (hora)`,
  startTimeHourMinute: `Hora de início (hora e minutos)`,
  startTimeHourMinuteSecond: `Hora de início (hora, minutos e segundos)`,
  startTimeLabel: `Hora de início`,
};
